/* eslint-disable standard/no-callback-literal */
import { ThirdPartyPayment } from 'javascript/Constants'

export function loadScript({ type, url }) {
  const script = document.createElement('script')
  if (type === ThirdPartyPayment.GMO && !window.Multipayment) {
    const gmoScript = document.createElement('script')
    gmoScript.setAttribute('src', url)
    document.head.appendChild(gmoScript)
  } else if (type === ThirdPartyPayment.GMOPayPal && !window.Multipayment) {
    script.setAttribute('src', url)
    document.head.appendChild(script)
  } else if (type === ThirdPartyPayment.Paygent && !window.PaygentToken) {
    const paygentScript = document.createElement('script')
    paygentScript.setAttribute('src', url)
    document.head.appendChild(paygentScript)
  }
}

export function registerCard(
  { shopId, token, type, holdername, cardno, expireMonth, expireYear, cvv },
  callback
) {
  let cardToken
  let resultDetails
  if ([ThirdPartyPayment.GMO, ThirdPartyPayment.GMOPayPal].includes(type)) {
    window.Multipayment.init(shopId)
    window.Multipayment.getToken(
      {
        holdername,
        cardno,
        expire: expireYear.toString().slice(2, 4) + expireMonth,
        securitycode: cvv
      },
      (response) => {
        const code = response.resultCode
        resultDetails = gmoStatusCodeToReason[code] || 'unknown'
        cardToken = response && response.tokenObject && response.tokenObject.token
        callback({
          cardToken,
          resultDetails,
          response
        })
      }
    )
  } else if (type === ThirdPartyPayment.Paygent) {
    const paygentToken = new window.PaygentToken()
    paygentToken.createToken(
      shopId,
      token,
      {
        card_number: cardno,
        expire_year: expireYear.toString().slice(2, 4),
        expire_month: expireMonth.padStart(2, '0'),
        cvc: cvv,
        name: holdername
      },
      (response) => {
        const code = response.result
        resultDetails = paygentStatusCodeToReason[code] || 'unknown'
        cardToken = response && response.tokenizedCardObject && response.tokenizedCardObject.token

        callback({
          cardToken,
          resultDetails,
          response
        })
      }
    )
  }
}

const PAYPAL_FE_HANDLED_ISSUE = [
  'INVALID_PARAMETER_SYNTAX',
  'INVALID_EXPIRATION_YEAR',
  'Invalid card number'
]

export const isPaypalFieldsOk = (evt) => {
  return (
    evt?.fields?.number?.isEmpty === false &&
    evt?.fields?.expirationDate?.isEmpty === false &&
    evt?.fields?.cvv?.isEmpty === false
  )
}

export const getPaypalIssue = (res) => {
  if (['INVALID_REQUEST', 'VALIDATION_ERROR'].includes(res?.name)) {
    return res.details?.[0]?.issue
  }
}

export const getPaypalIssueMessage = (err, vm) => {
  const issue = getPaypalIssue(err)
  if (PAYPAL_FE_HANDLED_ISSUE.includes(issue)) {
    return vm.$t(`triplaPayIssues.${issue.replace(/[-\s]+/gi, '_')}`)
  }
}

const gmoStatusCodeToReason = {
  '000': 'success',
  100: 'card',
  101: 'card',
  102: 'card',
  109: 'card',
  110: 'date',
  111: 'date',
  112: 'date',
  113: 'date',
  119: 'date',
  121: 'cvv',
  122: 'cvv',
  129: 'cvv',
  131: 'name_format',
  132: 'name',
  139: 'name'
}

// https://umami-me.atlassian.net/wiki/spaces/TECH/pages/1202159728/Get+paygent+card+token
const paygentStatusCodeToReason = {
  '0000': 'success',
  1300: 'card',
  1301: 'card',
  1400: 'date',
  1401: 'date',
  1500: 'date',
  1501: 'date',
  1502: 'date',
  1600: 'cvv',
  1601: 'cvv',
  1700: 'name'
}
